import { type UseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { GetUserProfileResponse } from 'generated/openapi';

import {
  getProfileKey,
  getProfileOptions,
  type ProfileKeyParams,
} from './getProfile.options';

export interface UseGetUserProfileProps<
  T = GetUserProfileResponse,
> extends ProfileKeyParams {
  options?: Omit<
    UseQueryOptions<GetUserProfileResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >;
}

export function useGetProfile<T = GetUserProfileResponse>({
  options,
  ...params
}: UseGetUserProfileProps<T>) {
  return useSuspenseQuery({
    ...getProfileOptions<T>(params),
    ...options,
  });
}

useGetProfile.getQueryKey = getProfileKey;
